<template>
  <div class="row mb-3">
    <div class="col-md-6">
      <el-form
        :inline="false"
        :rules="rules"
        :size="'small'"
        class="contact-form-inline"
        :label-position="'left'"
        :model="contact"
        v-if="loading == false"
      >
        <el-row
          v-for="colGroup in getContactFields[0]"
          style="margin-bottom: 4px"
          :gutter="4"
        >
          <el-col
            v-for="col in colGroup"
            :span="24 / colGroup.length"
            :xs="24 / colGroup.length"
            :sm="24 / colGroup.length"
            :md="(12 / colGroup.length) * 2"
            :lg="(12 / colGroup.length) * 2"
            :xl="(12 / colGroup.length) * 2"
          >
            <v-text-field
              v-if="col.attribute == 'first_name'"
              type="text"
              label="First Name"
              v-model="contact.first_name"
              @change="patchContact('first_name')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'last_name'"
              type="text"
              label="Last Name"
              v-model="contact.last_name"
              @change="patchContact('last_name')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'company_name'"
              type="text"
              label="Company Name"
              v-model="contact.company_name"
              @change="patchContact('company_name')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <!-- Email deviates from standard edit as we want to include refuse to give -->
            <VuetifyEmailConfirmInput
              v-if="col.attribute == 'email'"
              label="Email"
              v-model="contact.email"
              @change="patchContact('email')"
              :require-email="requireEmail"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <VuetifyPhoneInput
              v-if="col.attribute == 'mobile_phone'"
              :initial="contact.mobile_phone"
              :label="'Mobile Phone'"
              @update:phone="contact.mobile_phone = $event"
              @change="patchContact('mobile_phone')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <VuetifyPhoneInput
              v-if="col.attribute == 'home_phone'"
              :initial="contact.home_phone"
              :label="'Home Phone'"
              @update:phone="contact.home_phone = $event"
              @change="patchContact('home_phone')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'address_1'"
              label="Address Line 1"
              type="text"
              v-model="contact.address_1"
              @change="patchContact('address_1')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'address_2'"
              label="Address Line 2"
              type="text"
              v-model="contact.address_2"
              @change="patchContact('address_2')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'locality'"
              label="Locality / City"
              type="text"
              v-model="contact.locality"
              @change="patchContact('locality')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'region'"
              label="Region / State"
              type="text"
              v-model="contact.region"
              @change="patchContact('region')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'postal'"
              label="Postal Code"
              v-model="contact.postal"
              @change="patchContact('postal')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <VuetifyDatePicker
              v-if="col.attribute == 'birthday'"
              v-model="contact.birthday"
              label="Birthday"
              placeholder="Birthday"
              format="M-DD-YYYY"
              @change="patchContact('birthday')"
              :disabled="contact.is_locked"
            />
            <VuetifyDatePicker
              v-if="col.attribute == 'anniversary'"
              v-model="contact.anniversary"
              label="Anniversary"
              placeholder="Anniversary"
              format="M-DD-YYYY"
              @change="patchContact('anniversary')"
              :disabled="contact.is_locked"
            />
            <template v-if="col.attribute.startsWith('custom_fields')">
              <VuetifyNumberInput
                v-if="col.data_type == 'number'"
                :label="col.label"
                v-model="contact.custom_fields[col.field_name]"
                @update:model-value="patchContact('custom_fields')"
                autocomplete="off"
                :disabled="contact.is_locked"
              />

              <v-text-field
                v-if="col.data_type == 'string'"
                :label="col.label"
                v-model="contact.custom_fields[col.field_name]"
                @update:model-value="patchContact('custom_fields')"
                autocomplete="off"
                :disabled="contact.is_locked"
              />

              <v-select
                v-if="col.data_type == 'select'"
                v-model="contact.custom_fields[col.field_name]"
                :label="col.label"
                @update:model-value="patchContact('custom_fields')"
                :items="
                  col.values.map((v) => {
                    return { value: v.value, title: v.label };
                  })
                "
                autocomplete="off"
                :disabled="contact.is_locked"
                variant="outlined"
                density="compact"
              />
            </template>
          </el-col>
        </el-row>
        <el-tabs
          v-if="getProfiles?.length"
          v-model="selectedProfile"
          @tab-click="changeProfile"
          class="custom-field-profiles"
        >
          <el-tab-pane v-for="p of getProfiles" :label="p.label" :name="p.id">
            <template #label>
              <span>
                {{ p.label }}
                <font-awesome-icon
                  v-if="getUsedProfiles.includes(p.id)"
                  :icon="['fas', 'octagon-check']"
                />
              </span>
            </template>
            <el-row
              v-for="colGroup in getContactFields[selectedProfile]"
              style="margin-bottom: 4px"
              :gutter="4"
            >
              <el-col
                v-for="col in colGroup"
                :span="24 / colGroup.length"
                :xs="24 / colGroup.length"
                :sm="24 / colGroup.length"
                :md="(12 / colGroup.length) * 2"
                :lg="(12 / colGroup.length) * 2"
                :xl="(12 / colGroup.length) * 2"
              >
                <v-text-field
                  v-if="col.attribute == 'first_name'"
                  type="text"
                  label="First Name"
                  v-model="contact.first_name"
                  @change="patchContact('last_name')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-text-field
                  v-if="col.attribute == 'last_name'"
                  type="text"
                  label="Last Name"
                  v-model="contact.last_name"
                  @change="patchContact('last_name')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'company_name'"
                  type="text"
                  label="Company Name"
                  v-model="contact.company_name"
                  @change="patchContact('company_name')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-text-field
                  v-if="col.attribute == 'email'"
                  type="email"
                  label="Email"
                  placeholder="Enter a email address"
                  v-model="contact.email"
                  @change="patchContact('email')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <VuetifyPhoneInput
                  v-if="col.attribute == 'mobile_phone'"
                  :initial="contact.mobile_phone"
                  :label="'Mobile Phone'"
                  @update:phone="contact.mobile_phone = $event"
                  @change="patchContact('mobile_phone')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <VuetifyPhoneInput
                  v-if="col.attribute == 'home_phone'"
                  :initial="contact.home_phone"
                  :label="'Home Phone'"
                  @update:phone="contact.home_phone = $event"
                  @change="patchContact('home_phone')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-text-field
                  v-if="col.attribute == 'address_1'"
                  label="Address Line 1"
                  type="text"
                  v-model="contact.address_1"
                  @change="patchContact('address_1')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'address_2'"
                  label="Address Line 2"
                  type="text"
                  v-model="contact.address_2"
                  @change="patchContact('address_2')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'locality'"
                  label="Locality / City"
                  type="text"
                  v-model="contact.locality"
                  @change="patchContact('locality')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'region'"
                  label="Region / State"
                  type="text"
                  v-model="contact.region"
                  @change="patchContact('region')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'postal'"
                  label="Postal Code"
                  v-model="contact.postal"
                  @change="patchContact('postal')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-select
                  v-if="col.attribute == 'country'"
                  label="Country Code"
                  v-model="contact.country"
                  @update:model-value="patchContact('country')"
                  :items="
                    isoCountries.map((c) => ({
                      value: c.Code,
                      title: c.Name,
                    }))
                  "
                  variant="outlined"
                  density="compact"
                  :disabled="contact.is_locked"
                  hide-details="auto"
                  clearable
                />

                <VuetifyDatePicker
                  v-if="col.attribute == 'birthday'"
                  label="Birthday"
                  format="MM-DD-YYYY"
                  v-model="contact.birthday"
                  @update:model-value="patchContact('birthday')"
                  variant="outlined"
                  density="compact"
                  autocomplete="off"
                  :disabled="contact.is_locked"
                  hide-details="auto"
                  clearable
                />

                <VuetifyDatePicker
                  v-if="col.attribute == 'anniversary'"
                  label="Anniversary"
                  format="MM-DD-YYYY"
                  v-model="contact.anniversary"
                  @update:model-value="patchContact('anniversary')"
                  variant="outlined"
                  density="compact"
                  autocomplete="off"
                  :disabled="contact.is_locked"
                  hide-details="auto"
                  clearable
                />
                <template v-if="col.attribute.startsWith('custom_fields')">
                  <VuetifyNumberInput
                    v-if="col.data_type == 'number'"
                    :label="col.label"
                    v-model="contact.custom_fields[col.field_name]"
                    @update:model-value="patchContact('custom_fields')"
                    autocomplete="off"
                    :disabled="contact.is_locked"
                  />

                  <v-text-field
                    v-if="col.data_type == 'string'"
                    :label="col.label"
                    v-model="contact.custom_fields[col.field_name]"
                    @update:model-value="patchContact('custom_fields')"
                    autocomplete="off"
                    :disabled="contact.is_locked"
                  />

                  <v-select
                    v-if="col.data_type == 'select'"
                    v-model="contact.custom_fields[col.field_name]"
                    :label="col.label"
                    @update:model-value="patchContact('custom_fields')"
                    :items="
                      col.values.map((v) => {
                        return { value: v.value, title: v.label };
                      })
                    "
                    autocomplete="off"
                    :disabled="contact.is_locked"
                    variant="outlined"
                    density="compact"
                  />
                </template>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import VuetifyDatePicker from 'src/components/UIComponents/Inputs/VuetifyDatePicker.vue';
import VuetifyDateTimePicker from 'src/components/UIComponents/Inputs/VuetifyDateTimePicker.vue';
import VuetifyCurrencyInput from 'src/components/UIComponents/Inputs/VuetifyCurrencyInput.vue';
import VuetifyNumberInput from 'src/components/UIComponents/Inputs/VuetifyNumberInput.vue';
import VuetifyPhoneInput from 'src/components/UIComponents/Inputs/VuetifyPhoneInput.vue';
import VuetifyEmailConfirmInput from 'src/components/UIComponents/Inputs/VuetifyEmailConfirmInput.vue';

import contactServices from 'src/services/contactServices';
import PhoneNumber from 'src/components/UIComponents/Inputs/PhoneNumber';

export default {
  components: {
    PhoneNumber,
    // Vuetify
    VuetifyDatePicker,
    VuetifyCurrencyInput,
    VuetifyDateTimePicker,
    VuetifyNumberInput,
    VuetifyPhoneInput,
    VuetifyEmailConfirmInput,
  },
  props: {
    contactId: {
      type: Number,
      required: true,
    },
    requireEmail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    getContactTypes() {
      return this.contactTypes;
    },
    rules() {
      const rules = {
        // Add in any required fields here
      };
      for (const c of this.getCustomFields) {
        if (c.is_required) {
          rules['custom_fields.' + c.field_name] = [
            { required: true, trigger: 'change' },
          ];
        }
      }
      return rules;
    },
    ...mapGetters('appConfig', ['getAppConfig']),
    // ...mapGetters('contactType', ['getContactTypes']),
    ...mapGetters('customFields', ['getContactCustomFields']),
    ...mapGetters('formFieldProfiles', ['getFormFieldProfiles']),
    getUsedProfiles() {
      // Mostly efficient single pass to get used profiles.
      // Short circuits and checks at most N sub sets one for each profile
      // and returns as soon as first result is matched. Should be faster than
      // walking all the fields one time.
      if (!this.getContactFields || this.contact?.custom_fields?.length < 1) {
        return [];
      }

      const usedFields = Object.keys(this.contact.custom_fields);
      const used = this.getProfiles
        .map((p) => {
          if (!this.getContactFields[p.id]) {
            return undefined;
          }
          for (const [dOrd, vals] of Object.entries(
            this.getContactFields[p.id]
          )) {
            const found = vals.find((c) =>
              usedFields.includes(c.field_name)
            )?.profile_id;
            if (found) {
              return found.profile_id;
            }
            // Check next display order otherwise
          }
          return undefined;
        })
        .filter((u) => u != undefined);
      return used;
    },
    getProfiles() {
      // For now we just list all contact profiles.
      // Not sure we want to limit this to a specific contac type yet
      return this.getFormFieldProfiles
        .filter((p) => p.object_type == 'contact')
        .sort((a, b) =>
          a.display_order > b.display_order
            ? 1
            : b.display_order > a.display_order
            ? -1
            : 0
        );

      if (!this.getContactTypes || !this.contact?.contact_type_id) {
        return [];
      }
      const profileIds = this.getContactTypes
        .find((ct) => ct.id == this.contact.contact_type_id)
        .contactTypeProfiles.map((p) => p.profile_id);
      return this.getFormFieldProfiles.filter((p) => profileIds.includes(p.id));
    },
    getCustomFields() {
      const customFields = [];
      // should make the component load dependant on this being set.
      // ie v-if getContactTypes.... is not undefined
      /*
       SKIP contact types as its dumb
       if (!this.getContactTypes) {
         return custom_fields;
       }
       const contactType = this.getContactTypes.find(ct => ct.id == this.contact.contact_type_id);
       // This will happen on first load before contact type is selected
       if (!contactType) {
         return custom_fields;
       }
       const profileIds = contactType.contactTypeProfiles.map(p => p.profile_id);
       */
      // Just all profiles for now
      const profileIds = this.getProfiles.map((p) => p.id);

      this.getContactCustomFields.map((cf) => {
        if (cf.profile_id == null || profileIds.includes(cf.profile_id)) {
          customFields.push({
            ...cf, // augment custom fields with needed column attributes
            display_order: cf.display_order ?? 10,
            attribute: 'custom_fields.' + cf.field_name,
            label: cf.label,
          });
        }
      });
      return customFields;
    },
    getContactFields() {
      // Nest objects ordered by profile_id -> display_order
      // For each loop will be faster as nested is O(n2) but foreach would be O(n)
      const fields = {};
      for (const f of this.getAppConfig.contact.contactFormFields
        .slice()
        .concat(this.getCustomFields)) {
        // Convert null to 0 for consistancy
        const profileId = f.profile_id ?? 0;
        if (!fields[profileId]) {
          fields[profileId] = { [f.display_order]: [f] };
        } else {
          if (!fields[profileId][f.display_order]) {
            fields[profileId][f.display_order] = [f];
          } else {
            fields[profileId][f.display_order].push(f);
          }
        }
      }
      return fields;
    },
  },
  data() {
    return {
      loading: false,
      selectedProfile: undefined,
      valid: false,
      dirty: true,
      canPatch: false,

      contact: {
        id: null,
        first_name: '',
        last_name: '',
        address_1: '',
        address_2: '',
        locality: '',
        region: '',
        postal: '',
        country: 'US',
        home_phone: undefined,
        mobile_phone: undefined,
        email: undefined,
        refused_email_at: undefined,
        locale: 'en',
        timezone: '',
        company_name: undefined,

        unsubscribe_token: '',

        // Validation
        email_validated: undefined,
        email_validation_error: undefined,

        last_open_email: undefined,
        last_open_sms: undefined,
        last_sent_email: undefined,
        last_sent_sms: undefined,

        is_locked: false,
      },

      contactTypes: [
        {
          id: 1,
          name: 'Guest',
          is_default: true,
          contactTypeProfiles: [
            {
              id: 1,
              contact_type_id: 1,
              profile_id: 1,
              dislay_order: 1,
              is_default: true,
            },
            {
              id: 2,
              contact_type_id: 1,
              profile_id: 2,
              dislay_order: 2,
              is_default: false,
            },
          ],
        },
      ],
    };
  },
  watch: {
    contactId(n) {
      if (n) {
        this.loadContact();
      }
    },
  },

  async created() {
    await this.loadContact();
  },
  methods: {
    ...mapActions('contacts', ['deleteContactCache']),
    changeProfile(profileId) {
      // anything we need
    },
    async loadContact() {
      this.loading = true;
      this.selectedProfile = this.getProfiles
        ? this.getProfiles.find((p) => p.is_default)?.id
        : undefined;

      const contactData = await contactServices.fetchContactById(
        this.contactId
      );
      // Update the primary email
      contactData.data.email = contactData.data.primaryEmail
        ? contactData.data.primaryEmail.email_address
        : undefined;
      contactData.data.refused_email_at = contactData.data.refused_email_at
        ? true
        : false;

      if (!contactData.data.custom_fields) {
        contactData.data.custom_fields = {};
      }
      this.contact = contactData.data;

      // TODO: Just for testing until loaded
      this.contact.contact_type_id = 1;

      if (
        this.requireEmail &&
        !this.contact.email &&
        !this.contact.refused_email_at
      ) {
        this.valid = false;
      }

      this.dirty = false;
      this.valid = true;
      this.$emit('dirty', this.dirty);
      this.$emit('valid', this.valid);
      this.loading = false;
    },
    async updateMobile(newPhone) {
      // Only patch on change
      if (newPhone == this.contact.mobile_phone) {
        return;
      }
      this.contact.mobile_phone = newPhone;
    },
    async updateHome(newPhone) {
      this.contact.home_phone = newPhone;
    },
    async updateEmail(newEmail) {
      if (this.contact.email && this.contact.refused_email_at) {
        this.contact.refused_email_at = false;
      }
      return this.patchContact('email');
    },
    async patchContact(field) {
      if (this.contact.is_locked) {
        console.log('contact is locked');
        return;
      }

      this.valid = false;
      this.dirty = true;
      this.$emit('update:valid', this.valid);
      this.$emit('update:dirty', this.dirty);

      // Emit this after set dirty and invalid
      // TODO: this is inhibiting the patching of any other field until the user either enters an email or toggles refused to give.  Then, unless they change the fields again, the contact feild data will not be stored.  I don't think this is the desired outcome.
      if (
        this.requireEmail &&
        !this.contact.email &&
        !this.contact.refused_email_at
      ) {
        return false;
      }

      // Nulls need to unset properly
      if (this.contact[field] === '') {
        this.contact[field] = null;
      }

      // Cant patch until all required fields are entered.
      // Mostly around required custom fields as flat fields are fine
      // TODO: get this from the required fields rules and only save then
      const patch = {};

      // If patching custom fields it has to be a full set
      if (field.startsWith('custom_fields')) {
        // We drop all empty strings to unset the data points
        // TODO: need validate the data is what we want and required bits too
        patch.custom_fields = {};
        Object.keys(this.contact.custom_fields).forEach((k) => {
          if (this.contact.custom_fields[k] != '') {
            patch.custom_fields[k] = this.contact.custom_fields[k];
          }
        });
      } else if (field == 'refused_email_at') {
        // Unset if unchecked
        patch[field] = this.contact[field] ? new Date() : null;
      }
      // TODO: This will need to be reworked to support more than one email
      // Patch email
      else if (field == 'email') {
        patch.primary_email = this.contact[field];
        delete patch.email;
        patch.refused_email_at = null;
      } else {
        // ALl other fields are flat patches
        if (field == 'birthday' || field == 'anniversary') {
          patch[field] = this.contact[field]?.toISOString();
        }
        if (this.contact[field] === '') {
          this.contact[field] = null;
        }
        patch[field] = this.contact[field];
        // TODO: This will need to be reworked to support more than one email
        // Patch email
        if (patch.email) {
          patch.primary_email = patch.email;
          delete patch.email;
        }
      }

      if (patch == {}) {
        console.log('skipping empty patch');
        return false;
      }

      try {
        await contactServices.patchContact(this.contactId, patch);
        this.deleteContactCache(+this.id);
        this.valid = true;
        this.dirty = false;
        this.$emit('update:valid', this.valid);
        this.$emit('update:dirty', this.dirty);
      } catch (e) {
        // TODO: revert the fields on error otherwise they are out of sync
        this.$message({
          type: 'error',
          message: 'Error updating contact: ' + e.response.data,
        });
      }
    },
  },
};
</script>
<style>
.checkbox-container {
  display: flex;
  align-items: center;
  padding-right: 8px;
}

.error-message {
  color: white;
  font-size: 12px;
  background-color: #f56c6c;
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 4px;
  display: block;
}
</style>
